export const FETCH_ALL_SCHOOLS = 'FETCH_ALL_SCHOOLS';
export const GET_SCHOOL = 'GET_SCHOOL';
export const CREATE_SCHOOL = 'CREATE_SCHOOL';
export const UPDATE_SCHOOL = 'UPDATE_SCHOOL';
export const DELETE_SCHOOL = 'DELETE_SCHOOL';